/* eslint-disable func-names */
import * as yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { parse, isValid, differenceInYears } from 'date-fns';

import {
  INPUT_FIELD,
  INPUT_MASK_FIELD,
  PASSWORD_FIELD,
  RADIO_GROUP_FIELD,
  DROPDOWN_FIELD,
} from '../../../../constants/form/types';

import {
  FIELD_REQUIRED,
  INVALID_EMAIL,
  INVALID_PHONE_NUMBER,
  INVALID_DATE,
  MINIMUM_AGE_ERROR,
  MAXIMUM_AGE_ERROR,
} from '../../../../constants/validation/errors';

import Gender from '../../../../data/master/gender.json';
import Country from '../../../../data/master/countries.json';

const Register = {
  YupSchema: yup.object().shape({
    firstName: yup.string().required(FIELD_REQUIRED),
    lastName: yup.string().required(FIELD_REQUIRED),
    email: yup.string().email(INVALID_EMAIL).required(FIELD_REQUIRED),
    password: yup.string().required(FIELD_REQUIRED),
    phone: yup
      .string()
      .required(FIELD_REQUIRED)
      .test('phone-validate', null, function (value) {
        if (value && value.length > 1) {
          const number = parsePhoneNumberFromString(value, 'IN').formatInternational() || '';

          if (parsePhoneNumberFromString(number).isValid()) {
            return true;
          }

          return this.createError({
            path: this.path,
            message: INVALID_PHONE_NUMBER,
          });
        }

        return false;
      }),
    dob: yup
      .string()
      .required(FIELD_REQUIRED)
      .test('date-validate', null, function (value) {
        const parsedDate = parse(value, 'dd/MM/yyyy', new Date());

        if (isValid(parsedDate)) {
          const years = differenceInYears(new Date(), parsedDate) || 0;

          if (years < Number(process.env.REACT_APP_MINIMUM_AGE)) {
            return this.createError({
              path: this.path,
              message: `${MINIMUM_AGE_ERROR} ${Number(process.env.REACT_APP_MINIMUM_AGE)}`,
            });
          }

          if (years > Number(process.env.REACT_APP_MAXIMUM_AGE)) {
            return this.createError({
              path: this.path,
              message: `${MAXIMUM_AGE_ERROR} ${Number(process.env.REACT_APP_MAXIMUM_AGE)}`,
            });
          }

          return true;
        }

        return this.createError({
          path: this.path,
          message: INVALID_DATE,
        });
      }),
    gender: yup.string().required(FIELD_REQUIRED),
    country: yup.object().nullable().required(FIELD_REQUIRED),
  }),
  DefaultValues: {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phone: '',
    dob: '',
    gender: Gender[0].name,
    country: Country[0],
  },
  Template: {
    fields: [
      {
        type: INPUT_FIELD,
        name: 'firstName',
        label: 'First Name',
        required: true,
      },
      {
        type: INPUT_FIELD,
        name: 'lastName',
        label: 'Last Name',
        required: true,
      },
      {
        type: INPUT_FIELD,
        name: 'email',
        label: 'Email',
        required: true,
      },
      {
        type: PASSWORD_FIELD,
        name: 'password',
        label: 'Password',
      },
      {
        type: INPUT_MASK_FIELD,
        name: 'phone',
        label: 'Phone Number',
        mask: '9999999999',
        required: true,
      },
      {
        type: INPUT_MASK_FIELD,
        name: 'dob',
        label: 'Date Of Birth (DD/MM/YYYY)',
        mask: '99/99/9999',
        required: true,
      },
      {
        type: RADIO_GROUP_FIELD,
        name: 'gender',
        label: 'Gender',
        options: Gender,
        required: true,
      },
      {
        type: DROPDOWN_FIELD,
        name: 'country',
        label: 'Country',
        options: Country,
        required: true,
      },
    ],
  },
};

export default Register;
